// modal-dialog is already defined in global.js, so we just need to initialize the buttons

// Initialize size chart buttons to open modal
function initializeSizeChartButtons() {
  const sizeChartButtons = document.querySelectorAll('.size-chart-button, .size-chart-link');

  sizeChartButtons.forEach(button => {
    // Remove existing listener if already initialized
    if (button.dataset.sizeChartInitialized) return;
    button.dataset.sizeChartInitialized = 'true';

    button.addEventListener('click', function(event) {
      event.preventDefault();
      const modalId = this.getAttribute('aria-controls');
      const modal = document.getElementById(modalId);

      if (modal) {
        modal.show(this);
      }
    });
  });
}

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', initializeSizeChartButtons);

// Re-initialize when variant picker updates (for dynamic content)
document.addEventListener('variant:changed', initializeSizeChartButtons);

// Initialize immediately if DOM is already loaded
if (document.readyState === 'interactive' || document.readyState === 'complete') {
  initializeSizeChartButtons();
}
